export const buildTouchedFromErrors = (
  errors: Record<string, unknown>,
  prefix = ""
): Record<string, boolean> => {
  const touched: Record<string, boolean> = {};
  Object.entries(errors).forEach(([key, value]) => {
    const path = prefix ? `${prefix}.${key}` : key;
    if (typeof value === "string") {
      touched[path] = true;
    } else if (value && typeof value === "object") {
      Object.assign(
        touched,
        buildTouchedFromErrors(value as Record<string, unknown>, path)
      );
    }
  });
  return touched;
};

/** Coerce form/API values to RadioGroup string options ("true" / "false"). */
export const toRadioGroupStringValue = (
  value: unknown
): string | undefined => {
  if (value === true) return "true";
  if (value === false) return "false";
  if (value == null || value === "") return undefined;
  return String(value);
};

export const getNestedFormikValue = (fields, path: string) => {
  if (!path) return undefined;
  let targetKeys = path.split(".");

  for (let i = 0; i < targetKeys.length; i++) {
    let element = targetKeys[i];
    if (element.includes("[")) {
      const s = targetKeys[0].replace("[", "|").replace("]", "").split("|");
      targetKeys[i] = s[0];
      targetKeys.splice(i + 1, 0, s[1]);
    }
  }

  let value = null;
  targetKeys.forEach((targetKey: string) => {
    if (!value) {
      value = fields[targetKey];
    } else {
      value = value[targetKey];
    }
  });

  return value;
};

export const isNestedFormikValuePresent = (fields, path: string) => {
  return !!getNestedFormikValue(fields, path);
};
